import { AssistPropertyBM, ControlableObjectBasicInfo, LocalizedString, ResourceAssignType } from '@cue/api';

import { ResourceSchedule } from './resource-schedule.model';
import { CalendarWorkingHours } from '@cue/calendars';

export enum UnitInfoStatus {
  Online = 1,
  Offline = 2,
  Unregistred = 3,
}

export interface BreadcrumbItemWithId {
  item1: number;
  item2: LocalizedString;
}

export enum FileTypeEnum {
  Image = 1,
  Matterport = 2,
  Video = 3,
}

export interface FileData {
  imageUrl: string;
  matterportUrl: string;
  type: FileTypeEnum;
  imagePreferCover: boolean;
  imageObjectPosition: string;
}

export interface QrCode {
  name: LocalizedString;
  mapName: LocalizedString;
  file?: string;
  qrCodeId?: string;
  qrCategoryCodeId: string;
  showInResourceDetail: boolean;
}

export interface NavigationDetailInfo {
  name: LocalizedString;
  displayNameForApp?: LocalizedString;
  isAssignedTo: ResourceAssignType;
  resourceId: number | null;
  resourceGuid: string;
  qrCodeId: string | null;
  mapUrl: string;
  mapGeoData: string;
  reservable: boolean;
  breadcrumbWithIds: BreadcrumbItemWithId[];
  location: string[];
  files: FileData[];
  capacity: number | null;
  isCapacityUnlimited: boolean;
  areaId: number;
  daysOfWeek: string[];
  startTime: string | null;
  endTime: string | null;
  properties: (AssistPropertyBM & {
    visible: boolean;
    propertyTypeId: number;
    valueChoices: any[];
  })[];
  resourceTypeId: number;
  schedule: ResourceSchedule;
  resourceTypeName: LocalizedString;
  resourceTypeIcon: string | null;
  resourceDescription: LocalizedString;
  qrCodes: QrCode[];
  unitInformation: UnitInfo;
  qrCategoryName: LocalizedString;
  qrCategoryIcon: string;
  isResource?: boolean;
  currentFloorplanApp?: boolean;
  notNavigationPoint: boolean;
  imagePreferCover?: boolean;
  imageObjectPosition?: string;
  objects: ControlableObjectBasicInfo[];
  audioUrl: LocalizedString;
  workingHours: CalendarWorkingHours;
  setAsStart: boolean;
  setAsTarget: boolean;
  showCodeInDetail: boolean;
  qrCode: string;
  isReservable: boolean;
}

export interface UnitInfo {
  magicName: string;
  status: UnitInfoStatus;
  serialNumber: string;
  firmware: string;
  ipAddress: string;
  screenshot: string;
  screenshotId: string;
  lastActiveDateTime: Date | null;
  screenshotLastDownload: string | null;
  screenshotBlob: Blob;
}
